import styles from './PageHeaderBanner.module.scss';

import cx from 'classnames';
import React from 'react';

import { PromoBanner } from 'api/contentful/contentTypes.cloverdotcom';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { useReseller } from 'hooks/Reseller/useReseller';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { FlatEntry } from 'services/cms/flattenContentful';
import { ContentLinkV2 } from '../ContentLinkV2/ContentLinkV2';
import { BannerText } from './BannerText/BannerText';
import { BannerTitle } from './BannerTitle/BannerTitle';
import { toEntry } from 'services/cms/typesUtil';
import { redesignV2RoutePath } from 'constants/redesignV2';
import { useHistory } from 'react-router-dom';

interface IPageHeaderBannerProps {
  entry?: FlatEntry<PromoBanner>;
  children?: never;
}

export const PageHeaderBanner = React.forwardRef<HTMLDivElement, IPageHeaderBannerProps>((props, ref) => {
  const { programPromotion } = useReseller();
  const { browser } = useBreakpoints();
  const isDesktopOrLarger = browser.is.desktop;
  const { entry } = props;
  const history = useHistory();

  if (!programPromotion && !entry) return null;

  if (history.location.pathname.includes(redesignV2RoutePath.PURCHASE)) return null;

  return (
    <div className={styles.partnerBanner} ref={ref}>
      <div className={styles.container}>
        <div className={styles.textWrapper}>
          <BannerTitle
            currentPromotion={programPromotion}
            bannerTitle={entry?.enableCustomPromoCopy ? entry?.title : undefined}
          />
          <BannerText
            blurb={entry?.enableCustomPromoCopy ? entry?.blurb : undefined}
            currentPromotion={programPromotion}
          />
        </div>
        {entry?.cta && (
          <ContentLinkV2 entry={toEntry(entry.cta)} className={styles.link} hideTitle>
            <TextWithArrow theme="image" textClassName={cx(!isDesktopOrLarger && 'visually-hidden')}>
              {entry.cta.title}
            </TextWithArrow>
          </ContentLinkV2>
        )}
      </div>
    </div>
  );
});
